export const monthDetailBundle = {
  weekdays: {
    ko: ["일", "월", "화", "수", "목", "금", "토"],
    en: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    es: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"]
  },
  infoTitle: {
    ko: "이 달의 누수 패턴을 상세하게 확인하세요.",
    en: "Check the leak pattern for this month in detail.",
    es: "Consulte en detalle el patrón de fugas de este mes."
  },
  selectDate: {
    ko: "👆 날짜를 선택해주세요",
    en: "👆 Please select a date",
    es: "👆 Por favor, seleccione una fecha"
  },
  selectDesc: {
    ko: "해당 일자의 시간대별 상세 그래프를 볼 수 있습니다.",
    en: "You can view the hourly graph for the selected date.",
    es: "Puede ver el gráfico por horas de la fecha seleccionada."
  },
  chartTitleSuffix: {
    ko: "시간별 사용량",
    en: "Hourly Usage",
    es: "Consumo por hora"
  },
  headerDate: {
    ko: "년 월",
    en: "",
    es: ""
  }
}
